import "./BcrResultPopup.css";
import type { BcrFormulaAnalysis } from "../../utils/analyzeBaccaratFormula";
import { BCR_FORMULAS } from "../../utils/analyzeBaccaratFormula";

type BcrResultPopupProps = {
  tableTitle: string;
  analysis: BcrFormulaAnalysis;
};

export default function BcrResultPopup({ tableTitle, analysis }: BcrResultPopupProps) {
  const formulaLabel = BCR_FORMULAS.find((item) => item.id === analysis.formula)?.label ?? analysis.formula;
  const sideLabel = analysis.winner === "P" ? "Người chơi (P)" : "Nhà cái (B)";

  return (
    <div className="bcr-result-popup" onPointerDown={(event) => event.stopPropagation()}>
      <div className="bcr-result-popup__head">
        <span>
          <i />
          AI-CORE // TRUYỀN DỮ LIỆU
        </span>
        <em>
          <b />
          LIVE
        </em>
      </div>
      <strong className="bcr-result-popup__table">{tableTitle}</strong>
      <p>{`> Công thức: ${formulaLabel}`}</p>
      <p>{`> Dự đoán: ${sideLabel}`}</p>
      <p>{`> Độ tin cậy: ${analysis.forecast}%`}</p>
      <div className="bcr-result-popup__advice">{analysis.advice}</div>
      <div className="bcr-result-popup__hash" aria-hidden>
        {"////////////////////////"}
      </div>
    </div>
  );
}
